import { PopupPlacement } from 'src/types/popup.model';

export function popupPlacementToFlexDirectionClass(placement: PopupPlacement): string {
    switch (placement) {
        case PopupPlacement.BOTTOM:
            return 'flex-column';
        case PopupPlacement.LEFT:
            return 'flex-row-reverse';
        case PopupPlacement.TOP:
            return 'flex-column-reverse';
        default:
            return 'flex-row';
    }
}

export const SHIFT_SIZE: string = '10px';

export interface popupLeftTop {
    left: string;
    top: string;
}

export function popupPlacementToOffsetShift(placement: PopupPlacement, shiftSize: string = SHIFT_SIZE): popupLeftTop {
    switch (placement) {
        case PopupPlacement.BOTTOM:
            return { left: '0', top: shiftSize };
        case PopupPlacement.LEFT:
            return { left: `-${shiftSize}`, top: '0' };
        case PopupPlacement.TOP:
            return { left: '0', top: `-${shiftSize}` };
        default:
            return { left: shiftSize, top: '0' };
    }
}
